import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { TextField } from "@mui/material";
import { toast } from "react-toastify";
import { GetError } from "src/constant";
import { login, checkEmailAlreadyExists } from "src/thunks/auth";
import SigninImage from "src/assets/images/icon_signin.svg";
import { AuthenticationWrawper } from "src/components/AuthenticationWrawper";
import {emailValidationSchema, passwordvalidationSchema} from "src/helpers/yup_schema";

const Login = () => {

  /** redux store useDispatch & useSelector ------------------------------ **/
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const state = useSelector((state) => state.auth);
  const { isEmailExistsLoading, loginLoading } = useSelector((state) => state.auth);

  /** hooks useState ----------------------------------------------------- **/
  const [enteredEmail, setEnteredEmail] = useState("");
  const [passwordType, setPasswordType] = useState("password");
  const [emailError, setEmailError] = useState(false);
  const [steps, _steps] = useState(1);

  /** react hook form declaration ------------------------------ **/
  const {
    register: emailRegister,
    watch: emailFormWatch,
    handleSubmit: handleEmailSubmit,
    formState: { errors: errorsEmail },
    reset: resetEmailForm,
  } = useForm({
    resolver: yupResolver(emailValidationSchema),
  });

  const {
    register: passwordRegister,
    handleSubmit: handleSignInSubmit,
    watch: pwdFormWatch,
    formState: { errors: errorsPassword },
  } = useForm({
    resolver: yupResolver(passwordvalidationSchema),
  });

  /** Variable declarations ------------------------- **/
  const emailFieldValue = emailFormWatch("email", "");
  const emailFormButtonClassName =emailFieldValue == "" ? "email-form-disabled-button" : "email-form-enabled-button";
  const pwdFieldvalue = pwdFormWatch("password", "");
  const pwdFormButtonClassName =pwdFieldvalue == "" ? "email-form-disabled-button" : "email-form-enabled-button";

  /** hooks useEffect----------------------------------------------------- **/
  useEffect(() => {
    if (emailFieldValue == "") {
      setEmailError(false);
    }
  }, [emailFieldValue]);

  /** handler functions--------------------------------------------------- **/

  /** Function executes when enter email and click on next button ------------------ **/
  const onEmailSubmitHandler = async (data) => {
    try {
      localStorage.setItem("email", data.email);
      await dispatch(checkEmailAlreadyExists(data.email))
        .unwrap()
        .then((result) => {
          if (result) {
            setEmailError(false);
            _steps(2);
            setEnteredEmail(data.email);
          } else {
            setEmailError(true);
          }
        });
    } catch (error) {
      toast.error(GetError(error?.response?.data?.errors) || "something issue");
    }
  };

  /** Function executes when user tries to signin -----------------------  **/
  const onSignInSubmitHandler = async (data) => {
    const credentials = {
      email: enteredEmail,
      password: data.password,
    };
    try {
      let result = await dispatch(login(credentials)).unwrap();
      if (result) {
        navigate("/app");
      }
    } catch (err) {
      if (
        Object.keys(err?.response?.data?.errors || "").includes("UnAuthorized")
      ) {
        navigate("/error", {
          state: { error: GetError(err?.response?.data?.errors) },
        });
      } else {
        toast.error(GetError(err?.response?.data?.errors) || "Something issue");
      }
    }
  };

  /** Function executes when toggle password field ------------------ **/
  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };

  /** Function executes to reset email field and go back to the first email screen */
  const handleEmailButtonClick = () => {
    _steps(1);
    setEnteredEmail("");
    resetEmailForm();
  };
  
  return (
    <AuthenticationWrawper>
      {steps === 2 || !enteredEmail == "" ? (
        <>
          <div className="signin-text welcome-text-style">Welcome</div>
          <div
            className="entered-email-style pt-1"
            onClick={handleEmailButtonClick}
          >
            {enteredEmail}
          </div>
          <div style={{ marginTop: 30, width: "85%" }}>
            <form
              className="login-form-main-class"
              onSubmit={handleSignInSubmit(onSignInSubmitHandler)}
            >
              <div className="login-formfield">
                <div style={{ position: "relative" }}>
                  <TextField
                    className="depot-form-textfields-style"
                    type={passwordType}
                    {...passwordRegister("password")}
                    id="standard-basic"
                    label="Password"
                    variant="standard"
                  />
                </div>
                <div
                  style={{
                    position: "absolute",
                    right: 28,
                    top: 115,
                    cursor: "pointer",
                  }}
                >
                  {passwordType === "password" ? (
                    <i
                      className="bi bi-eye-slash-fill"
                      onClick={togglePassword}
                    ></i>
                  ) : (
                    <i className="bi bi-eye-fill" onClick={togglePassword}></i>
                  )}
                </div>
                <div
                  className="d-flex justify-content-start mt-2 email-not-registered-error"
                  style={{
                    height: 23,
                  }}
                >
                  {errorsPassword.password?.message && (
                    <>
                      <i
                        className="bi bi-exclamation-circle-fill me-1"
                        style={{ fontSize: 11 }}
                      ></i>
                      {errorsPassword.password?.message}
                    </>
                  )}
                  {state.error && (
                    <>
                      <i
                        className="bi bi-exclamation-circle-fill me-1"
                        style={{ fontSize: 11 }}
                      ></i>
                      {state.error}
                    </>
                  )}
                </div>
              </div>
              <div
                className="d-flex flex-row justify-content-between "
                style={{
                  height: 50,
                  paddingTop: 15,
                  marginBottom: 8,
                }}
              >
                <span
                  className="d-flex justify-content-center fw-bold create-an-account-button-style"
                  onClick={() => navigate("/forgot")}
                >
                  Forgot password ?
                </span>
                <div
                  className="d-flex flex-column"
                  style={{ position: "absolute", right: 0 }}
                >
                  <button
                    disabled={
                      pwdFieldvalue == "" || loginLoading == true ? true : false
                    }
                    className={`${pwdFormButtonClassName}  ${
                      loginLoading ? "fade-out" : ""
                    } d-flex justify-content-center align-items-center next-button-style`}
                    type="submit"
                  >
                    SIGN IN
                    <img
                      className="ms-1"
                      src={SigninImage}
                      width={15}
                      height={15}
                    />
                  </button>
                  <div className="d-flex justify-content-end">
                    <i className="bi bi-caret-right-fill fold-button-styling"></i>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </>
      ) : (
        <>
          <div className="signin-text">
            Sign in using your registered email id
          </div>
          <div
            style={{ marginTop: 35, width: "85%" }}
            className="form-field-class"
          >
            <form
              className="login-form-main-class"
              onSubmit={handleEmailSubmit(onEmailSubmitHandler)}
            >
              <TextField
                className="depot-form-textfields-style"
                {...emailRegister("email")}
                id="standard-basic"
                label="Email"
                variant="standard"
              />
              <div
                className="d-flex flex-column justify-content-start"
                style={{
                  height: 104,
                }}
              >
                {errorsEmail.email?.message && (
                  <>
                    <div className="d-flex flex-row mt-2 email-not-registered-error">
                      <i
                        className="bi bi-exclamation-circle-fill me-2"
                        style={{ fontSize: 11 }}
                      ></i>
                      {errorsEmail.email?.message}
                    </div>
                  </>
                )}
                {emailError ? (
                  <>
                    <div className="d-flex flex-row mt-2 email-not-registered-error">
                      <i
                        className="bi bi-exclamation-circle-fill me-2"
                        style={{ fontSize: 11 }}
                      ></i>
                      This email is not registred with us. please check the
                      spelling or try with another email
                    </div>
                  </>
                ) : (
                  ""
                )}
                {emailError ? (
                  <span className="d-flex justify-content-start ms-3 mt-2 email-info-msg-shown">
                    If you are a customer and would like to register with this
                    email, please talk to your Muztrans representative
                  </span>
                ) : (
                  ""
                )}
              </div>
              <div
                className="d-flex flex-row justify-content-between login-buttons "
                style={{ height: 50, paddingTop: 15, marginBottom: 8 }}
              >
                <span
                  className="d-flex justify-content-center fw-bold create-an-account-button-style"
                  onClick={() => navigate("/createnew")}
                >
                  Create an account
                </span>
                <div
                  className="d-flex flex-column"
                  style={{ position: "absolute", right: 0 }}
                >
                  <button
                    disabled={
                      emailFieldValue == "" || isEmailExistsLoading == true
                        ? true
                        : false
                    }
                    className={`${emailFormButtonClassName}  ${
                      isEmailExistsLoading ? "fade-out" : ""
                    } d-flex justify-content-center align-items-center next-button-style`}
                    type="submit"
                  >
                    NEXT
                    <i className="bi bi-arrow-right-short arrow-size-for-login"></i>
                  </button>
                  <div className="d-flex justify-content-end">
                    <i className="bi bi-caret-right-fill fold-button-styling"></i>
                  </div>
                </div>
              </div>
              <div></div>
            </form>
          </div>
        </>
      )}
    </AuthenticationWrawper>
  );
};

export default Login;
